import { useMutation } from "@apollo/client";
import React, { useState } from "react";
import { SEND_NOTIFICATION } from "./graphql";
import { Box, Button, Container, TextField } from "@mui/material";
import { toast } from "react-toastify";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Controller, useForm } from "react-hook-form";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { DatePicker } from "@mui/x-date-pickers";
import { ZonedDateTimePicker } from "../../components/ZonedDateTimePicker";
import { FaqLabel } from "../edition/edit/form";
import dayjs from "dayjs";
import { ErrorRenderer } from "../../components/ErrorRenderer";
import { LoadingIndicator } from "react-select/dist/declarations/src/components/indicators";
import { LoadingOverlay } from "../../components/Loading";

const schema = yup
  .object({
    title: yup
      .string()
      .required()
      .max(50, "Title must be a maximum of 50 characters"),
    message: yup
      .string()
      .required()
      .max(178, "Push notifications can have a maximum of 178 characters"),
    sendAfter: yup.string(),
  })
  .required();

export const SendNotification = () => {
  // export number
  const { id: exportNumber } = useParams();
  
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const postId = params.get('postId');  

  console.log('postId', postId)
  
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [sendNotification, { data, error }] = useMutation(SEND_NOTIFICATION, {
    onCompleted: () => {
      toast("Notification sent");
      setTimeout(() => {
        navigate("/notification/history");
      }, 2000);
    },
    onError: (error) => {
      toast(JSON.stringify(error));

      setLoading(false);
    },
  });
  const {
    register,
    handleSubmit,
    watch,
    control,
    setValue,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  const onSubmit = (data: {
    title: string;
    message: string;
    sendAfter: string | undefined;
  }) => {
    if (loading) return;

    setLoading(true);

    const { title, message, sendAfter } = data;
    const exportNum = exportNumber?.length === 0 ? null : exportNumber;

    sendNotification({
      variables: {
        title,
        message,
        exportNumber: exportNum,
        sendAfter: sendAfter ? new Date(sendAfter).toISOString() : undefined,
        postId,
      },
    });
  };

  return (
    <Box style={{ backgroundColor: "white", padding: 18, marginTop: 20 }}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <h2>Send a notification</h2>
        {exportNumber && (
          <h3>
            As you have updated the lineup, Do you want to send notification
            update to the app?
          </h3>
        )}
        {!loading && (
          <>
            <TextField
              id="outlined-basic"
              label="Title"
              variant="outlined"
              {...register("title")}
              style={{ width: "80%" }}
            />
            <p>{errors.title?.message}</p>
            <TextField
              id="outlined-basic"
              label="Message"
              multiline
              minRows={18}
              style={{ width: "80%" }}
              variant="outlined"
              {...register("message")}
            />
            <p>{errors.message?.message}</p>
          </>
        )}

        <LoadingOverlay loading={loading} />

        {!loading && (
          <div
            style={{
              width: "80%",
              display: "flex",
              flexDirection: "row",
              // justifyContent: "start",
              alignItems: "start",
            }}
          >
            <Controller
              control={control}
              name="sendAfter"
              render={({ field: { onChange } }) => (
                <ZonedDateTimePicker
                  format="YYYY/MM/DD HH:mm"
                  ampm={false}
                  label="Send after"
                  defaultValue={undefined}
                  onChange={(value) => {
                    if (value === null) {
                      setValue("sendAfter", undefined);
                    } else {
                      // @ts-ignore
                      onChange(value);
                    }
                  }} // send value to hook form
                >
                  <FaqLabel style={{ marginTop: 4 }}>
                    Schedule a notification to send in the future, leave blank
                    to send right away.
                  </FaqLabel>
                </ZonedDateTimePicker>
              )}
            />
          </div>
        )}
        <ErrorRenderer errors={errors} />

        <Button type="submit" variant="contained" disabled={loading}>
          Send
        </Button>
      </form>
    </Box>
  );
};
